var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCobertura(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "28px",
    height: "28px",
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ubicacion") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 28,
    height: 28
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Editar-producto",
    transform: "translate(-35.000000, -518.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ubicacion",
    transform: "translate(35.000000, 518.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Background"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0000851,4.88928204 C11.1503189,4.88928204 8.8317871,7.2078138 8.8317871,10.0575797 C8.8317871,12.9073454 11.1503189,15.225878 14.0000851,15.225878 C16.849851,15.225878 19.1683831,12.9073475 19.1683831,10.0575807 C19.1683831,7.20781463 16.849851,4.88928204 14.0000845,4.88928204 L14.0000851,4.88928204 Z M14.0000816,13.475874 C12.1152233,13.475874 10.5817871,11.942436 10.5817871,10.0575778 C10.5817871,8.17271964 12.1152233,6.63928204 14.0000816,6.63928204 C15.8849402,6.63928204 17.4183774,8.17271964 17.4183774,10.0575778 C17.4183774,11.942436 15.8849402,13.475874 14.0000816,13.475874 L14.0000816,13.475874 Z M23.8960173,6.8310766 C23.4520078,5.29058425 22.650398,3.95303791 21.5135561,2.85562366 C19.6340532,1.04136574 16.8962904,0.000607818352 14.0021711,6.1035156e-05 C14.0012962,6.1035156e-05 14.0009122,6.1035156e-05 13.9999837,6.1035156e-05 C11.1070143,6.1035156e-05 8.36941365,1.03983449 6.48969498,2.85261574 C5.35285102,3.94893564 4.55091384,5.28527967 4.10603048,6.82429503 C3.62674923,8.48236563 3.57796807,10.3391156 3.96094454,12.3429745 C4.75347565,16.4897087 7.34850711,21.1624283 11.6811789,26.2499512 L8.01777306,26.2499512 C7.5344992,26.2499512 7.14277302,26.6416775 7.14277302,27.1249517 C7.14277302,27.6082242 7.5344992,27.999951 8.01777306,27.999951 L19.9823059,27.999951 C20.4655775,27.999951 20.8573057,27.6082242 20.8573057,27.1249517 C20.8573057,26.6416775 20.4655775,26.2499512 19.9823059,26.2499512 L16.3188432,26.2499512 C20.6473573,21.1673507 23.2416803,16.4985678 24.0368913,12.3545667 C24.4217804,10.3490122 24.3743663,8.49067684 23.8960173,6.83107492 L23.8960173,6.8310766 Z M13.9999461,26.2466332 C5.52765074,16.7492189 3.17275231,8.48260104 7.70437672,4.11224818 C9.32279785,2.55146681 11.6611808,1.77124024 13.9998364,1.77124024 C16.3396412,1.77124024 18.6797196,2.55250592 20.2980295,4.11470906 C24.826648,8.48626378 22.4704356,16.7507493 13.9999446,26.2466332 L13.9999461,26.2466332 Z",
    id: "Shape",
    fill: "currentColor",
    mask: "url(#mask-2)"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCobertura);
export default __webpack_public_path__ + "static/media/cobertura.ac908991c40530e84c6163073260103f.svg";
export { ForwardRef as ReactComponent };